/* tslint:disable */
import { ValueError } from "../../Errors/ValueError";
import { getDomElementAsNotNullable } from "../../utils/layoutUtils";
import 'datatables.net';
import 'datatables.net-responsive';
import moment from "../../../../node_modules/moment/moment";
export class TimeTableWrapperAutoCol {
    constructor(options) {
        var _a;
        this.tableID = options.tableID;
        this.tableElement = getDomElementAsNotNullable(options.tableID);
        //Default true
        if (options.spinnerElement !== true) {
            let spinnerElement = (_a = this.tableElement.parentElement) === null || _a === void 0 ? void 0 : _a.getElementsByClassName("spinner-border")[0];
            if (spinnerElement === undefined) {
                throw new ValueError("No spinner element found for this table");
            }
            this.spinnerElement = spinnerElement;
        }
        this.graphDatasets = [];
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - (options.pastDays !== undefined ? options.pastDays : 100));
        this.endDate = new Date();
        this.endDate.setDate(this.endDate.getDate() + (options.forecastDays !== undefined ? options.forecastDays : 2));
        this.isForecastTable = options.isForecastTable;
    }
    /**
     * Includes the timestamp column
     * */
    get numberOfColumns() {
        return this.tableElement.rows[0].cells.length;
    }
    /**
     * Excludes the timestamp column
     * */
    get numberOfDataSets() {
        return this.graphDatasets.filter(d => d !== undefined).length;
    }
    /**
     * Gets the legnth of the first element that is not undefined
     * */
    get dataRowLength() {
        let filtered = this.graphDatasets.filter(d => d !== undefined);
        if (filtered.length === 0) {
            throw new Error("No datasets yet defined");
        }
        return filtered[0].length;
    }
    drawNew() {
        if (this.graphDatasets.length === 0) {
            console.warn("No datasets were added");
            return;
        }
        let filteredDatasets = this.graphDatasets.map(data => data.filterByMinMaxDate(this.startDate.toISOString(), this.endDate.toISOString()));
        let numberOfRowstoInsert = filteredDatasets[0].length;
        //We loop through each row of the data creating a single row at a time.
        for (let rowIndex = 0; rowIndex < numberOfRowstoInsert; rowIndex++) {
            //to insert at end use: this.tableElement.rows.length - 1;
            let row = this.tableElement.insertRow(rowIndex + 1);
            //Insert 0th row which is used for row ordering
            row.insertCell(0).innerHTML = `${rowIndex + 1}`;
            //Format and insert timestamp
            row.insertCell(1).innerHTML = moment.utc(filteredDatasets[0].timeSeries[rowIndex]).format("DD/MM/YY HH:mm");
            //row.insertCell(1).innerHTML = new Date(filteredDatasets[0].timeSeries[rowIndex]).toLocaleString("en-gb", { timeZone: 'UTC' });
            for (let columnIndex = 0; columnIndex < filteredDatasets.length; columnIndex++) {
                let currentValue = filteredDatasets[columnIndex].values[rowIndex];
                if (currentValue === null) {
                    row.insertCell(columnIndex + 2).innerHTML = "";
                }
                else {
                    row.insertCell(columnIndex + 2).innerHTML = (Math.round((currentValue + Number.EPSILON) * 100) / 100).toString(); //Math.round(currentValue).toString();
                }
            }
            function formatHeaderTitle(theDate) {
                return moment.utc(theDate).format("DD/MM/YY HH:mm");
            }
        }
        //Removes row that forces inserts into tbody
        getDomElementAsNotNullable("placeholderRow").remove();
        //Must be done before datatables initilises
        this.tableElement.style.visibility = "visible";
        //TODO: take columndefs from this.columndefs
        $("#" + this.tableID).DataTable({
            /**
             * This is a callback that runs over every row of the table.
             *
             * */
            rowCallback: (row, cellsInThisRow, index) => {
                if (!Array.isArray(cellsInThisRow) || this.isForecastTable !== true) {
                    return;
                }
                //if (index === 0 || index === 1) return;
                let now = new Date();
                let inTheFuture = undefined;
                let observedValueForThisRow = -1;
                cellsInThisRow.forEach((cellValue, cellIndex) => {
                    //Formats the time series based on if they are in future or past
                    if (cellIndex === 1) {
                        if (moment(cellValue, "DD/MM/YYYY hh:mm:ss").toDate() > now) {
                            $(row).find(`td:eq(${cellIndex - 1})`).css('background-color', '#eedfae');
                            inTheFuture = true;
                        }
                        else {
                            $(row).find(`td:eq(${cellIndex - 1})`).css('background-color', '#c9fffd');
                            inTheFuture = false;
                        }
                        return;
                    }
                    // the observed column
                    if (cellIndex === 2) {
                        if (cellValue === "") {
                            observedValueForThisRow = 0;
                            return;
                        }
                        observedValueForThisRow = cellValue; // I think its a string at this point
                        return;
                    }
                    if (cellIndex === 0 || cellValue.includes("/") || inTheFuture === true)
                        return;
                    //There isn't much that JS won't interpret as a number
                    if (cellValue == "")
                        return;
                    if (Math.abs(cellValue - observedValueForThisRow) > 10) {
                        $(row).find(`td:eq(${cellIndex - 1})`).css('background-color', '#F6A8A6');
                    }
                    else if (Math.abs(cellValue - observedValueForThisRow) > 5) {
                        $(row).find(`td:eq(${cellIndex - 1})`).css('background-color', '#F9F0C1');
                    }
                    else if (Math.abs(cellValue - observedValueForThisRow) >= 0) {
                        $(row).find(`td:eq(${cellIndex - 1})`).css('background-color', '#C0ECCC');
                    }
                });
            },
            scrollY: '400px',
            scrollX: this.isForecastTable,
            order: [[0, 'desc']],
            responsive: this.isForecastTable === undefined ? true : false,
            columnDefs: [
                //This is a hidden column to prevent sorting by string date which happens by default
                {
                    targets: 0, className: "all", visible: false, orderable: false,
                } //,
                //This is the time column. Disable ordering becuse JS will order by STRING, not date. - removed April 2022 - might be reinstated
                //{
                //targets: 1, className: "all", orderable: false,
                //},
            ],
            paging: false,
            search: false,
            searching: false,
        });
        if (this.spinnerElement !== undefined) {
            this.spinnerElement.style.display = "none";
        }
        // I think we fire off resize every couple seconds anyway
        window.dispatchEvent(new Event('resize'));
    }
    /**
     *
     *
     * @param columnTitle Don't forget the \n
     * @param columnData
     */
    addColumn(columnTitle, columnData) {
        //20210611
        if (this.graphDatasets.length !== 0 && this.dataRowLength !== columnData.length) {
            //throw new ValueError(`Expected ${this.dataRowLength} rows of data but data had ${columnData.length} rows`);
            console.log(`Expected ${this.dataRowLength} rows of data but data had ${columnData.length} rows`);
        }
        this.graphDatasets.push(columnData);
        let theader = this.tableElement.getElementsByTagName("thead")[0];
        let columnHeaders = theader.getElementsByTagName("tr");
        if (columnHeaders.length === 0) {
            throw new Error("No column header row specified for this table.");
        }
        //The table may include headers that span multiple columns.
        let columnHeaderRow = columnHeaders[columnHeaders.length - 1];
        //let theader = this.tableElement.getElementsByTagName("thead")[0].getElementsByTagName("tr")[0];
        let element = document.createElement("th");
        element.innerHTML = columnTitle;
        columnHeaderRow.appendChild(element);
    }
}
